import type {
  EntryCohortConfig,
  EntryEventConfig,
  EntryAudienceExperimentConfig,
  EntryAudienceExperimentBranchConfig,
  EntryAudienceExperimentSplitGroup,
  JourneyNodeConfig as BackendJourneyNodeConfig,
  JourneySyncExitConfig,
  JourneyExitCriteriaConfig,
  SegmentBranchConfig,
  SegmentsConfig,
  SyncConfig,
  TimeDelayConfig,
  NextMatchingTimeSchedule,
  WaitUntilEventBranchConfig,
  WaitUntilEventConfig,
  SplitsConfig,
  SplitBranchConfig,
  NoOpConfig,
  ContextConfig,
  CouponAssignmentConfig,
  MessageNodeConfig,
  JourneyContextVariable,
  JourneyContextVariableDefinition,
  JourneyContextVariableType,
  JourneyNodeStatus,
} from "@hightouch/lib/journeys/types/config-types";
import {
  JourneyNodeSyncMode,
  JourneyNodeType as BackendJourneyNodeType,
  JourneyStatus,
  destinationTypeExternalSegmentPropertyMap,
  messageNodeConfigSchema,
  entryCohortConfigSchema,
  entryEventConfigSchema,
  entryAudienceExperimentConfigSchema,
  entryAudienceExperimentBranchConfigSchema,
  maxNumberEntrySchema,
  maxSimultaneousEntriesSchema,
  reEntryDelaySchema,
  segmentBranchConfigSchema,
  segmentsConfigSchema,
  syncConfigSchema,
  waitUntilEventBranchConfigSchema,
  waitUntilEventConfigSchema,
  splitsConfigSchema,
  splitBranchConfigSchema,
  contextConfigSchema,
  couponAssignmentConfigSchema,
  COLUMN_TYPE_TO_CONTEXT_TYPE,
} from "@hightouch/lib/journeys/types/config-types";

// Remove NoOp config from the backend type. Only used for testing in backend.
export type JourneyNodeConfig = Exclude<BackendJourneyNodeConfig, NoOpConfig>;

// Frontend-only: extend JourneyNodeType with Note
// The journey node-type is a frontend only concept
export const NOTE_NODE_TYPE = "journey-note";
export const JourneyNodeType = {
  ...BackendJourneyNodeType,
  Note: NOTE_NODE_TYPE,
} as const;

// Type counterpart to the value above
export type JourneyNodeType =
  (typeof JourneyNodeType)[keyof typeof JourneyNodeType];

export type {
  EntryCohortConfig,
  EntryEventConfig,
  EntryAudienceExperimentConfig,
  EntryAudienceExperimentBranchConfig,
  EntryAudienceExperimentSplitGroup,
  JourneySyncExitConfig,
  JourneyExitCriteriaConfig,
  SegmentBranchConfig,
  SegmentsConfig,
  SyncConfig,
  TimeDelayConfig,
  NextMatchingTimeSchedule,
  WaitUntilEventBranchConfig,
  WaitUntilEventConfig,
  SplitsConfig,
  SplitBranchConfig,
  ContextConfig,
  CouponAssignmentConfig,
  MessageNodeConfig,
  JourneyContextVariable,
  JourneyContextVariableDefinition,
  JourneyContextVariableType,
  JourneyNodeStatus,
};

export {
  JourneyNodeSyncMode,
  JourneyStatus,
  destinationTypeExternalSegmentPropertyMap,
  messageNodeConfigSchema,
  entryCohortConfigSchema,
  entryEventConfigSchema,
  entryAudienceExperimentConfigSchema,
  entryAudienceExperimentBranchConfigSchema,
  maxNumberEntrySchema,
  maxSimultaneousEntriesSchema,
  reEntryDelaySchema,
  segmentBranchConfigSchema,
  segmentsConfigSchema,
  syncConfigSchema,
  waitUntilEventBranchConfigSchema,
  waitUntilEventConfigSchema,
  splitsConfigSchema,
  splitBranchConfigSchema,
  contextConfigSchema,
  couponAssignmentConfigSchema,
  COLUMN_TYPE_TO_CONTEXT_TYPE,
};
